import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import DatePicker from 'react-date-picker';
import './NewTravelAllowance.scss';
import MyContext from '../MyContext.jsx';
import axios from 'axios';
import {epochToDate} from '../../assets/js/handy.mjs';
import imageCompression from 'browser-image-compression';
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

class NewTravelAllowance extends Component {
  url = `${process.env.REACT_APP_SSS}`;
  constructor(props) {
    super(props);
    this.typeSelect = React.createRef();
    this.rowContainerRef = React.createRef();
    this.state = {
      id : '',
      date : new Date(),
      allowance_head : [],
      total : 0,
      no_of_visited : 0,
      ta_head:[],
      selected_head:'',
      rows: [],
      route_visited :[],
      fileDeleted:0,
      employee_del_ids:[],
      currency : ''
    }
    this.formChange = this.formChange.bind(this);
    this.headChange = this.headChange.bind(this);
    this.handleAddRow = this.handleAddRow.bind(this);
    this.handleRemoveSpecificRow = this.handleRemoveSpecificRow.bind(this);
    this.imageOpen = this.imageOpen.bind(this);
    this.imageClose = this.imageClose.bind(this);
    this.totalAMountCalc = this.totalAMountCalc.bind(this);

  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    var obj_this = this;
    const {pathname} = this.props.location;
    obj_this.setState({
      currency: obj_this.context.currency
    });
    if(pathname === "/travel/allowance/new") {
      const url = `${process.env.REACT_APP_SSS}/api/getTravelAllowanceDetails`;
      this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        if(return_data.status == "success"){
          var allowance_head = return_data.allowance_head;
          obj_this.setState({
            ta_head: return_data.ta_head,
          });
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });

      obj_this.onDateChange(this.state.date)
    }else{
      const ta_id = this.props.match.params.ta_id;
      const url = `${process.env.REACT_APP_SSS}/api/editTravelAllowanceDetails`;
      this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          ta_id : ta_id,
          sid : this.context.user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        if(return_data.status == "success"){
          obj_this.setState({
            id : ta_id,
            ta_head: return_data.ta_head,
            date : new Date(epochToDate(return_data.state_object.ta_date)),
            total :parseFloat(return_data.state_object.total).toFixed(3)
          });
          var state_object = return_data.state_object.ta_details;
          for(var i=0;i<state_object.length;i++){
            var ta_img= state_object[i]['attachment'];
            if(ta_img){
            var ta_img_type= ta_img.split('.').pop();
            console.log(ta_img_type);
            }
            var cost=state_object[i]['ta_cost']
            var ta_cost=parseFloat(cost).toFixed(3)
            let item = {};
            item['kilometers'] = state_object[i]['ta_qty'];
            item['rupees'] = ta_cost;
            item['parent_name'] = state_object[i]['parent_name'];
            item['parent_id'] = state_object[i]['type_id'];
            item['title_head'] = state_object[i]['name'];
            item['ta_head_id'] = state_object[i]['ta_head_id'];
            item['duration'] = state_object[i]['duration'];
            item['amount'] = parseFloat(state_object[i]['ta_price']).toFixed(3);
            item['remarks'] = state_object[i]['remarks'];
            item['attachment'] = state_object[i]['attachment'];
            item['employee_ta_id'] = state_object[i]['employee_ta_id'];
            item['file']='';
            item['image']='';
            item['isOpen']=false;
            item['image_flag']='N';
            item['im_type']= ta_img_type;
            console.log(item)


            obj_this.setState({
              rows: [...obj_this.state.rows, item]
            });              
          }
          obj_this.onDateChange(epochToDate(return_data.state_object.ta_date));
          
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
     
    }
    obj_this.scrollToLastRow();
  }

  scrollToLastRow = () => {
    const rows = this.rowContainerRef.current.children;
    const lastRow = rows[rows.length - 1];
    lastRow.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };



  handleAddRow = () => {
    
    if(this.state.rows.length>0){
      if(!this.validateDetails(this.state.rows)){
        return;
      }
    }
    if(!this.state.selected_head){
        return;
      }

    const selected_head = this.state.selected_head
    var travel_amount = selected_head.ta_details?.amount??0
    const item = {
      title_head:selected_head.label,
      ta_head_id:selected_head.value,
      duration:selected_head.duration??0,
      parent_name:selected_head.parent_name,
      parent_id:selected_head.parent_id,
      kilometers:"",
      amount: travel_amount, 
      rupees: '',
      remarks:"",
      image:null,
      file:"",
      compress_image:"",
      attachment:"",
      image_flag:"N",
      isOpen:false
    };
   
    this.setState({
      rows: [...this.state.rows, item],
      selected_head:'',
    },() => {
      this.scrollToLastRow();
    });
    
  };


  handleRemoveSpecificRow = (idx) => () => {
   
    const rows = [...this.state.rows];
    rows.splice(idx, 1);
    this.setState({ 
      rows 
    });
    
    this.find_total(rows);
    const del_ids = this.state.rows[idx].employee_ta_id;
   
   
    this.setState({
      employee_del_ids: [...this.state.employee_del_ids, del_ids]
    });
                    
  }
  
  headChange(value) {
    
    this.setState({
      selected_head: value,
    });
    
  } 
  remarksChange(e,idx){
    var rows = [...this.state.rows];
    var item = rows[idx];
    item.remarks = e.target.value;
    this.setState({
      rows
    });
  }

  onDateChange(value){
    if(!value)
      return
    this.setState({date : value});
    console.log(value);
    const url2 = `${process.env.REACT_APP_SSS}/api/getTravelAllowanceVisitedDetails`;
    this.context.loading(1);
    var obj_this=this;
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        ta_date:value.toLocaleString('en-CA', { timeZone: 'Asia/Kolkata' })
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          no_of_visited : return_data.no_of_visited,
          route_visited : return_data.route_visited,
        });
        
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }

  formChange(e,idx){
    var rows = [...this.state.rows];
    var item = rows[idx];
    var entered_amount = parseFloat(e.target.value);
    if(entered_amount > item.amount && item.amount!=0){
      alert("MAXIMUM ALLOWED FOR "+item.title_head+" PER DAY IS "+ this.state.currency +' '+parseFloat(item.amount).toFixed(3));
      entered_amount = parseFloat(item.amount).toFixed(3);
    }
    if(entered_amount<0){
      alert(item.title_head+" CANNOT BE NEGATIVE");
      entered_amount=parseFloat(0).toFixed(3);
    }
    item[e.target.name] = entered_amount;
    this.find_total(rows);
    this.setState({rows});
  }

  kilometerChange(e,idx){
    var rows = [...this.state.rows];
    var item = rows[idx];
    item[e.target.name] = e.target.value;
    console.log(item);
    item.rupees = parseFloat(item.kilometers *  item.amount).toFixed(3);
    this.find_total(rows);
    this.setState({rows});
  }

  find_total(rows){
    var total = 0;
    for(var i=0;i<rows.length;i++){
      if(rows[i]['rupees'])
        total = +parseFloat(total).toFixed(3) + +parseFloat(rows[i]['rupees']).toFixed(3);
    }
    this.setState({
      total : parseFloat(total).toFixed(3)
    });
  }
  
  uploadImage = (e,idx) => {
    console.log(e.target.files[0]);
   
    var rows = [...this.state.rows];
    var item = rows[idx];
    
    if (e.target.files && e.target.files[0]) {
      item.attachment = ''
      item.file = URL.createObjectURL(e.target.files[0]);
      item.image_flag ='Y';

      var png= 'image/png';
      var jpg= 'image/jpg';
      var jpeg= 'image/jpeg';
      var typ= 'image/png';
      item.type=e.target.files[0].type;
      console.log(item.type);

      if(e.target.files[0].type==png || e.target.files[0].type==jpg || e.target.files[0].type==jpeg){
        var new_img = e.target.files[0];
        const options = {
              maxSizeMB: 1,
              maxWidthOrHeight: 1024,
              useWebWorker: true,
              initialQuality: 0.85,
            };
        if (options.maxSizeMB >= new_img / 1024) {  
         return;
        }
        let output;
        imageCompression(new_img, options).then((x) => {
          output = x;
          item.image= output;
        });
        console.log(output);
      }else{
        item.image= e.target.files[0];
      }
      // item.image =e.target.files[0];

    }else{
      item.file = ''
      item.image = ''
      item.image_flag ='N';
    }
    this.setState({
      rows
    });
   console.log(item)

  }

  totalAMountCalc(){
    console.log(this.state.rows);
    let list = this.state.rows;
    const reduced = list.reduce((prev, curr) => {
      const key = `${curr.ta_head_id}`
      return {
          ...prev,
          [key]: [...(prev[key] || []), curr]
      }
    }, {})
  
    const filtered = Object.values(reduced).filter(v => v.length > 0)
    console.log(filtered);

    for(var i=0;i<filtered.length;i++){
      const am= filtered[i];
      const sum = am
        .map(obj => obj.rupees)
        .reduce((accumulator, current) => Math.round(accumulator*100)/100 + Math.round(current*100)/100, 0);
      console.log(sum);
      
      
      var head_id=am[0].ta_head_id;
      var head_name=am[0].title_head;
      var max_amount=am[0].amount;
      var ta_parent=am[0].parent_name;
      console.log(head_id,max_amount,sum,ta_parent);
      console.log(am);
      if(sum>max_amount && max_amount!=0 && ta_parent!='TRAVEL'){
        alert('Total Amount of '+head_name+' exceeded')
        return false;
      }
     
    }
    return true;
  }

  validateDetails(details) {
    for(var i = 0; i < details.length; i++) {
      // Use data-index instead of index attribute
      const container = document.querySelector(`.container[data-index="${i}"]`);
      
      if(details[i].parent_name === "TRAVEL") {
        const kilometers = parseFloat(details[i].kilometers);
        if(isNaN(kilometers) || kilometers <= 0) {
          container?.querySelector(".kilometers")?.focus();
          return false;
        }
      }
      
      if(details[i].parent_name !== "TRAVEL") {
        const rupees = parseFloat(details[i].rupees);
        if(isNaN(rupees) || rupees <= 0) {
          container?.querySelector(".rupees")?.focus();
          return false;
        }
      }
    }
    return true;
  }


  formSubmit(e){
    e.preventDefault();
    
    if(!this.validateDetails(this.state.rows)){
      return;
    }
    if(!this.totalAMountCalc()){
      return;
    }
    var allowance =this.state;
    var allowance_details={};
    allowance_details.rows = this.state.rows;
    console.log(allowance_details);
    allowance_details.ta_date = allowance.date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    allowance_details.id = allowance.id;
    var ta_date = this.state.date;
    var fd= new FormData();
    fd.append('sid',this.context.user_details.sid)
    fd.append ('ta_date',ta_date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    fd.append('total',this.state.total);
    fd.append('id',this.state.id);
    fd.append('employee_del_ids',this.state.employee_del_ids)
    for (let i = 0; i < this.state.rows.length; i++) {
      fd.append("title_head[]", this.state.rows[i]['title_head']);
      fd.append("ta_head_id[]", this.state.rows[i]['ta_head_id']);
      // fd.append("duration[]", this.state.rows[i]['duration'])
      fd.append("parent_name[]", this.state.rows[i]['parent_name'])
      fd.append("parent_id[]", this.state.rows[i]['parent_id'])
      fd.append("kilometers[]", this.state.rows[i]['kilometers'])
      fd.append("amount[]", this.state.rows[i]['amount'])
      fd.append("rupees[]", this.state.rows[i]['rupees'])
      fd.append("remarks[]", this.state.rows[i]['remarks'])
      fd.append("image[]", this.state.rows[i]['image']??'no_image')
      fd.append("file[]", this.state.rows[i]['file']??'no_image')
      fd.append("employee_ta_id[]", this.state.rows[i]['employee_ta_id'])
      fd.append("image_flag[]", this.state.rows[i]['image_flag'])
      console.log(fd)
    }
    console.log(fd);
    console.log(allowance_details);
    const url = `${process.env.REACT_APP_SSS}/api/saveAllowanceDetails`;
    this.context.loading(1);
    var obj_this = this;
    axios.post(url,fd)
    .then(return_data =>{
      console.log(return_data);
      if(return_data.data.status == "create"){
        alert("Allowance inserted.");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/travel/allowance');
      }else if(return_data.data.status == "update"){
        alert("Allowance updated.");
        obj_this.context.loading(0);
        obj_this.props.history.replace('/travel/allowance');
      }else if(return_data.data.status == "exist"){
        alert("Allowance exist on Selected Date. Please select another date.");
        obj_this.context.loading(0);
        // obj_this.props.history.replace('/travel/allowance');
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    })
  }
  getComponent(e,idx) {
    var rows = [...this.state.rows];
    var item = rows[idx];
    item.image ='';
    item.file ='';
    item.attachment ='';
    this.setState({
      rows
    });

    this.setState({
      fileDeleted :1
    });
  }
  imageOpen(e,idx){
    var rows = [...this.state.rows];
    var item = rows[idx];
    item.isOpen =true;
    
    this.setState({
      rows
    });
  }
  imageClose(e,idx){
    var rows = [...this.state.rows];
    var item = rows[idx];
    item.isOpen =false;
    
    this.setState({
      rows
    });
  }

  render(){
    const { rows } = this.state;
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_travel_allowance_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> {this.state.id?"Edit":"New"} Travel Allowance</div>
          </div> 
          <form className="allowance_head_form" onSubmit={e => this.formSubmit(e)} >
            <div className="allowance_details_container travel_blocks">
              <div className=" date_container"><span className="travel_label">Date :&nbsp;</span>
                  <DatePicker
                  className="input date"
                  onChange={(value) => this.onDateChange(value)}
                  value={this.state.date}
                  format="dd-MM-y"
                  required
                  disabled={this.state.id}
                  minDate={this.state.id ?new Date(this.state.date):new Date(new Date().setDate(new Date().getDate() - 7))}
                  maxDate={new Date()}
                  clearIcon={true}
                  /> 
              </div>
              <div className="travel_label">No of Visit :&nbsp;{this.state.no_of_visited}</div>
              <div className="travel_label">Routes visited :&nbsp;<span>{this.state.route_visited.length >0?'':'nill'}</span></div>
              <div style={{display:this.state.route_visited.length >0?"block":"none"}}>
              {this.state.route_visited.map((item, idx) => ( 
                <ul >
                  <li key={idx}  >{item.route_name} </li>
                </ul>
                ))}
              </div>
              <div className="travel_label">HEAD</div>
              <div className="select_add">
                <div>
                    <Select 
                    options={this.state.ta_head}  
                    value ={this.state.selected_head}
                    className="ta_head" 
                    ref={this.headSelect}
                    onChange={this.headChange}
                    required
                    />
                </div>    
                <div >
                  <button className="add_product_button"
                  type="button"
                  onClick={this.handleAddRow}
                  >
                    <i className="fa fa-plus"></i> Add
                  </button>
                </div>
              </div>
            </div>

          </form>           
 
          <form className="travel_allowance_form" onSubmit={e => this.formSubmit(e)}  ref={this.rowContainerRef}> 
            
            {this.state.rows.map((item, idx) => (
              <div className="blocks container"  key={idx} data-index={idx}  style={{display:this.state.rows.length >0?"block":"none"}}>
                <div className="title_delete">
                  <div className="block_title">{item.title_head}</div>
                  <i className="delete_product_button fa fa-trash-alt" 
                    type="button"
                    onClick={this.handleRemoveSpecificRow(idx)}></i>
                </div>

                <div className="input_grid" >
                  <div style={{display:item.parent_name == "TRAVEL"?"grid":"none"}}>
                    <div className="input_label">Kms</div>
                    <input className="kilometers input custom_input"
                      type="number"
                      name="kilometers"
                      value={item.parent_name === "TRAVEL" ? (item.kilometers || '') : ''}
                      min="0.001"
                      step={0.001}
                      onChange={e => this.kilometerChange(e,idx)}
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <div className="input_label">{this.state.currency}</div>
                    <input className="rupees input custom_input"
                      type="number"
                      name="rupees"
                      value={this.state.rows[idx].rupees}
                      onChange={e => this.formChange(e,idx)}
                      autoComplete="off"
                      min="0.001"
                      step={0.001}
                      disabled={item.parent_name == "TRAVEL"}
                    />
                  </div>
                </div>


                <div className="maximum_price"><i className="fas fa-info-circle"></i> Maximum {this.state.currency}{parseFloat(item.amount).toFixed(3)}/{item.duration}</div>

                <div className="input_label">Remarks <span className="remarks"></span></div>
                <input className="remarks input custom_input"
                  type="text"
                  name="remarks"
                  value={this.state.rows[idx].remarks}
                  onChange={e => this.remarksChange(e,idx)}
                  // autoComplete="off"
                />
                <div style={{marginBottom:'10px'}} className="custom_file_upload">
                {/* <div className="input_label">Upload Photo</div> */}
                <i class="fa fa-camera" aria-hidden="true"></i>
                <label htmlFor={`file_upload_${idx}`} className="custom_input_label">Upload Photo</label>
                <input className="file_upload"
                  id={`file_upload_${idx}`}
                  type="file"
                  name="image[]"
                  
                  accept="image/png, image/jpg, image/jpeg, application/pdf" 
                  onChange={e => this.uploadImage(e,idx)}
                  autoComplete="off"

                />
                </div>
                {/* <div>
                {this.state.rows[idx].attachment?<span>
                {item.im_type!='png' || item.im_type!='jpg' || item.im_type!='jpeg'?
                <span style={{fontSize:'10px'}}>{this.state.rows[idx].attachment}</span>:''}</span>:''}
                </div> */}
                {this.state.id ?
                  <span>
                  {this.state.rows[idx].attachment?
                    <span className="form-group multi-preview" style={{ marginTop: '10px', display: this.state.rows[idx].attachment ? "block" : "none" }}>
                    {item.im_type=='png' || item.im_type=='jpg' || item.im_type=='jpeg'?

                      <span className="thumbnail">

                        <img src={`${this.url}/${this.state.rows[idx].attachment}`} onClick={(e) => this.imageOpen(e,idx)} alt="no image" className="ret_img" name="ret_img" />
                        <a>  <i className="close far fa-times-circle" name="iclose" onClick={(e) => this.getComponent(e,idx)} > </i></a>

                      </span>:''}

                      <span className="ril__builtinButton">

                      {this.state.rows[idx].isOpen && (
                        <Lightbox
                          mainSrc={`${this.url}/${this.state.rows[idx].attachment}`}                         
                          onCloseRequest={(e) => this.imageClose(e,idx)}                         
                        />
                      )}

                      </span>


                    </span>:
                    <span className="form-group multi-preview" style={{ marginTop: '10px', display: item.file ? "block" : "none" }}>
                       {item.type=='image/png' || item.type=='image/jpg' || item.type=='image/jpeg'?

                      <span className="thumbnail">

                        <img src={item.file} onClick={(e) => this.imageOpen(e,idx)} alt="no image" className="ret_img" />
                        <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e,idx)} > </i></a>

                      </span>:''}

                      <span className="ril__builtinButton"> 

                      {this.state.rows[idx].isOpen && (
                        <Lightbox
                          mainSrc={item.file}                         
                          onCloseRequest={(e) => this.imageClose(e,idx)}
                        />
                      )}

                      </span>

                    </span>
                  }
                  </span>
                  :
                  <span className="form-group multi-preview" style={{ marginTop: '10px', display: item.file ? "block" : "none" }}>
                    {item.type=='image/png' || item.type=='image/jpg' || item.type=='image/jpeg'?
                    <span className="thumbnail">

                      <img src={item.file} onClick={(e) => this.imageOpen(e,idx)} alt="no image" className="ret_img" />
                      <a>  <i className="close far fa-times-circle" onClick={(e) => this.getComponent(e,idx)} > </i></a>

                    </span>:''}

                    <span className="ril__builtinButton"> 

                      {this.state.rows[idx].isOpen && (
                        <Lightbox
                          mainSrc={item.file}                         
                          onCloseRequest={(e) => this.imageClose(e,idx)}
                        />
                      )}

                    </span>

                  </span>

                }
              </div>
              
            ))}

            <div type="button" className="blocks grand_total" style={{display:parseFloat(this.state.total)>0?"block":"none"}}>Grand Total : {this.state.currency}. {this.state.total}</div>
            <button type="submit" className="submit_button" style={{visibility:this.state.rows.length >0?"visible":"hidden"}}>
            <i className="far fa-save"></i> Save</button>
            
          </form>
                      
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewTravelAllowance;
NewTravelAllowance.contextType = MyContext;
